import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `${theme.spacing(2)} 0`};

  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};

  color: ${({ theme }) => theme.palette.text.primary};
`;
